<template>
  <v-dialog v-model="dialog" scrollable fullscreen>
    <v-card>
      <v-card-title class="d-flex align-baseline">
        <span>#{{ job.id || '-' }} - {{ title }}</span>
      </v-card-title>

      <v-card-subtitle class="d-flex align-baseline justify-space-between">
        <span>queue: {{ job.queue || '-' }}</span>
        <span v-if="job.failed_at">failed_at: {{ job.failed_at }}</span>
        <span v-else>created_at: {{ job.created_at || '-' }}</span>
      </v-card-subtitle>

      <v-card-text>
        <div v-for="(field, index) in fields" :key="`${field.key}-${index}`" class="mb-5">
          {{ field.key }}
          <AppCode :value="field.value" />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="dialog = false" text>Voltar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      title: "Job",
      job: {},
    };
  },

  computed: {
    fields() {
      const entries = Object.entries(this.job || {});

      return entries.map(([key, value]) => {
        return {
          key,
          value: this.normalizeValue(value),
        };
      });
    },
  },

  methods: {
    open(title, data) {
      this.title = title || "Job";
      this.job = JSON.parse(JSON.stringify(data || {}));

      if (this.job.payload) {
        this.job.payload_parsed = this.tryParseJson(this.job.payload);
      }

      this.dialog = true;
    },

    normalizeValue(value) {
      if (value === null || value === undefined) {
        return "-";
      }

      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }

      return String(value);
    },

    tryParseJson(value) {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (error) {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
